import React from "react";
import Card from "../components/card";
import Main from "../components/main";
export default function Aboutus() {
  let content =
    "We are a health tech company committed to building innovative diabetes solutions using the power of artificial intelligence. With over 24 years of combined experience—14 years in technology and 10 years in healthcare.";
  return (
    <Main>
      <Card activeContent="About us" content={content} />
    </Main>
  );
}
